export const getLongestWordLength = string => {
  const words = string.split(" ")
  let longest = 0

  for (let x = 0; x < words.length; x++) {
    const length = words[x].length
    longest = length > longest ? length : longest
  }

  return longest
}

export const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]
